import { UUID } from '../../../core/pojo/id-variable';
import { LocalDate } from '../../../core/pojo/date-variable';
import { MetricDataRole } from './MetricData';
import { MetricMini } from './Metric';
import { CompanyPortfolioAnalysisDto } from '../../recovery/component/recovery-company/dto/CompanyWithOrgDto';
import { MetricDataType, MetricSign } from '../../recovery/component/recovery-metrics-panel/entity/DefaultMetric';

export class MetricPortfolioAnalysis {
  uuid: UUID;
  orgUUID: UUID;
  bundles: MetricPortfolioAnalysisBundle[];
}

export class MetricPortfolioAnalysisBundle {
  uuid: UUID;
  period: LocalDate;
  role: MetricDataRole;
  tableOrder: number;
  metric: MetricMini;
}

export class MetricPortfolioAnalysisWrapper {
  analysisUUID: UUID;
  companies: MetricPortfolioAnalysisWrapperCompany[];
}

export class MetricPortfolioAnalysisWrapperGrouping {
  all: MetricPortfolioAnalysisWrapper;
  tracked: MetricPortfolioAnalysisWrapper;
  untracked: MetricPortfolioAnalysisWrapper;
}

export class MetricPortfolioAnalysisWrapperCompany {
  company: CompanyPortfolioAnalysisDto;
  entries: MetricPortfolioAnalysisWrapperEntryDTO[];
}

export class MetricPortfolioAnalysisWrapperEntryDTO {
  metricGroupName: string;
  metricName: string;
  role: MetricDataRole;
  period: {
    expected: LocalDate;
    provided: LocalDate;
    isMatchingPeriod: boolean;
  };

  data: {
    uuid: UUID;
    sign: MetricSign;
    rawValue: string;
    metricDataType: MetricDataType;
  };
}

export class KpiAnalysisChartSetUp {
  orgId: number;
  timeFrame: string;
  metricGroupName: string;
  metricName: string;
  role: string;
  isTotal: boolean;
  companyUUID?: string;
  companyName?: string;
}

export class KpiAnalysisChartDTO {
  xAxis: string[];
  yAxis: string[];
}
